// extracted by mini-css-extract-plugin
export var banner = "_gm-0";
export var closeButton = "_gm-2";
export var greenCheckmark = "_gm-3";
export var hereLink = "_gm-4";
export var titleIcon = "_gm-1";